import XEUtils from 'xe-utils';
import { warnLog } from '../../tools/log';
var VXEMenusStore = /** @class */ (function () {
    function VXEMenusStore() {
        this.store = {};
    }
    VXEMenusStore.prototype.mixin = function (options) {
        var _this = this;
        XEUtils.each(options, function (item, key) {
            _this.add(key, item);
        });
        return this;
    };
    VXEMenusStore.prototype.has = function (name) {
        return !!this.get(name);
    };
    VXEMenusStore.prototype.get = function (name) {
        return this.store[name];
    };
    VXEMenusStore.prototype.add = function (name, render) {
        var conf = this.store[name];
        // 兼容
        if (XEUtils.isFunction(render)) {
            if (process.env.NODE_ENV === 'development') {
                warnLog('vxe.error.delProp', ['menus -> callback', 'menuMethod']);
            }
            render = {
                menuMethod: render
            };
        }
        // 检测是否覆盖
        if (process.env.NODE_ENV === 'development') {
            var confKeys_1 = XEUtils.keys(conf);
            XEUtils.each(render, function (item, key) {
                if (confKeys_1.includes(key)) {
                    warnLog('vxe.error.coverProp', [name, key]);
                }
            });
        }
        this.store[name] = conf ? XEUtils.merge(conf, render) : render;
        return this;
    };
    VXEMenusStore.prototype.delete = function (name) {
        delete this.store[name];
    };
    VXEMenusStore.prototype.forEach = function (callback) {
        XEUtils.objectEach(this.store, callback);
    };
    return VXEMenusStore;
}());
export var menus = new VXEMenusStore();
if (process.env.NODE_ENV === 'development') {
    Object.assign(menus, { _name: 'Menus' });
}
